import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { __DEV__ } from '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import Box from '../Box/index.esm.js';
import Card from '../Card/index.esm.js';
import Icon from '../Icon/index.esm.js';
import CloseButton from '../CloseButton/index.esm.js';
import mapTheme from './styles.esm.js';
import AlertContext from './context.esm.js';
export { default as AlertActions } from './AlertActions/index.esm.js';
export { default as AlertBody } from './AlertBody/index.esm.js';
export { default as AlertButton } from './AlertButton/index.esm.js';
export { default as AlertDescription } from './AlertDescription/index.esm.js';
export { default as AlertTitle } from './AlertTitle/index.esm.js';

var getIcon = function getIcon(appearance) {
  switch (appearance) {
    case 'error':
      return 'warning';

    default:
      return appearance;
  }
};

var Alert = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var children = props.children,
      onClose = props.onClose,
      _props$appearance = props.appearance,
      appearance = _props$appearance === void 0 ? 'warning' : _props$appearance,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'default' : _props$variant,
      _props$display = props.display,
      display = _props$display === void 0 ? 'flex' : _props$display,
      _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'items-center' : _props$alignItems,
      _props$padding = props.padding,
      padding = _props$padding === void 0 ? variant === 'default' ? 'p-3' : undefined : _props$padding,
      _props$textAlign = props.textAlign,
      textAlign = _props$textAlign === void 0 ? 'text-left' : _props$textAlign,
      rest = _objectWithoutPropertiesLoose(props, ["children", "onClose", "appearance", "variant", "display", "alignItems", "padding", "textAlign"]);

  var theme = mapTheme(appearance);
  var context = {
    appearance: appearance,
    theme: theme,
    variant: variant
  };
  return React__default.createElement(AlertContext.Provider, {
    value: context
  }, React__default.createElement(Card, _extends({
    role: "alert",
    ref: ref,
    display: display,
    padding: padding,
    alignItems: alignItems,
    textAlign: textAlign,
    borderWidth: variant === 'subtle' ? 'border-0' : 'border',
    boxShadow: variant === 'subtle' ? 'shadow-none' : 'shadow-sm'
  }, rest), React__default.createElement(Box, {
    borderRadius: "rounded-full",
    borderWidth: variant === 'default' ? 'border-4' : undefined,
    // @ts-ignore - Union too complex
    borderColor: variant === 'default' ? theme.iconBorderColor : undefined,
    backgroundColor: variant === 'default' ? 'bg-white' : undefined
  }, React__default.createElement(Icon, {
    name: getIcon(appearance),
    flexShrink: "flex-shrink-0",
    color: theme.textColor,
    height: "h-5",
    width: "w-5",
    display: "block"
  })), React__default.createElement(Box, {
    display: "md:flex",
    alignItems: "items-center",
    flex: "flex-1",
    margin: "ml-3"
  }, children), onClose && React__default.createElement(CloseButton, {
    onClick: onClose,
    alignSelf: "self-center",
    margin: "ml-2"
  })));
});

if (__DEV__) {
  Alert.displayName = 'Alert';
}

export default Alert;
//# sourceMappingURL=index.esm.js.map
